import React from "react";
import { Box, Flex, IconOnePassMembershipCard, Text, } from "@catchoftheday/cg-components";
export const CurrentBenefit = () => {
    return (<Flex alignItems="center">
      <Box flex="1 1 auto" mr={5}>
        <IconOnePassMembershipCard color="onePass.primaryDarker" width="42px" height="auto"/>
      </Box>
      <Box flex="1 1 auto" width="100%">
        <Text fontSize="base" color="onePass.textPrimary" m={0} fontWeight="normal">
          All current Catch and OnePass benefits, for the same price.
        </Text>
      </Box>
    </Flex>);
};
